import { RobotAgent } from "../RobotAgent";
import { RTVisualizer } from "./RTVisualizer";
import * as THREE from "three";
export class Lidar3DVisualizer extends RTVisualizer {
  private origin = new THREE.Mesh(
    new THREE.ShapeGeometry(new THREE.Shape().moveTo(0, 0).lineTo(0.1, 0)),
    new THREE.MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 0.05 })
  );
  constructor(agent: RobotAgent) {
    super(agent);
    this.origin.position.x = 0.55;
    this.origin.position.z = 0.5;
    this.origin.name = "Lidar3DVisualizer";
    const previous = this.agent.visual.obj.getObjectByName("Lidar3DVisualizer");
    if (previous) {
      previous.removeFromParent();
    }
    this.agent.visual.obj.add(this.origin);    
  }

  public update(data: number[]) {
    if (!this.active) {
      this.origin.visible = false;
      return;
    }
    this.origin.visible = true;
    const size = data.length / 3;
    // console.log("Lidar3DVisualizer update with size:", size);
    for (let i = 0; i < size; i++) {
      const x = data[i * 3];
      const y = data[i * 3 + 1];
      const z = data[i * 3 + 2];
      let mesh = this.origin.children[i];
      if (!mesh) {
        mesh = new THREE.Mesh(
          new THREE.SphereGeometry(0.01, 8, 8),
          new THREE.MeshBasicMaterial({ color: 0xff0000 })
        );
        this.origin.add(mesh);
      }
      mesh.position.set(x, y, z);
      // console.log("Lidar3DVisualizer update mesh:", mesh.position);
      mesh.visible = true;
    }
    for (let i = size; i < this.origin.children.length; i++) {
      const mesh = this.origin.children[i];
      mesh.visible = false;
    }
  }
}